
import { TemplateOptionsEnum as TemplateOptions } from "@/module/main";
import { Component } from "vue-property-decorator";
import { HcPageModel } from "@dev/hc-components";

@Component
export default class TemplateList extends HcPageModel {
    public name: string = "template-list";
    protected pageName: string = 'templateList';

    get templates(): object {
        return TemplateOptions;
    }

    private loadTemplate(template: string): void {
        this.$emit("loadTemplate", template);
    }
}
